/* ユニアム 長寿研究プロジェクト — 共通スクリプト */
(function () {
  "use strict";
  var D = window.ULL || {};
  var L = D.links || {};
  
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- ヘッダー・フッター・固定CTA ---------- */
  var NAV = [
    ["/pages/longevitylab#about", "長寿研究について", "index"],
    ["/pages/longevitylab#story", "研究への想い", ""],
    ["/blogs/cat-researchers/", "ねこ研究員名鑑", "meikan"],
    ["/pages/longevitylab-journal/", "研究だより", "genzaichi"],
    ["/pages/longevitylab-faq/", "よくある質問", "faq"]
  ];
  var pgEl = document.querySelector("[data-page]");
  var page = pgEl ? pgEl.getAttribute("data-page") : "";

  function renderChrome() {
    if (page !== "boshu") {
      var s = document.createElement("div");
      s.className = "sticky-cta";
      s.innerHTML = '<a class="btn btn--primary" href="/pages/longevitylab-join/">ねこ研究員に参加する<span class="arrow" aria-hidden="true">→</span></a>';
      document.body.appendChild(s);
    } else {
      var s2 = document.createElement("div");
      s2.className = "sticky-cta";
      s2.innerHTML = '<a class="btn btn--primary" href="' + esc(L.form) + '" target="_blank" rel="noopener">応募フォームを開く<span class="arrow" aria-hidden="true">↗</span></a>';
      document.body.appendChild(s2);
    }
  }

  /* ---------- リンクと未確定項目の差し込み ---------- */
  function bindData() {
    $all("[data-link]").forEach(function (a) {
      var k = a.getAttribute("data-link");
      if (L[k]) a.setAttribute("href", L[k]);
      else if (a.getAttribute("href") === "#") a.insertAdjacentHTML("afterend", ' <span class="pending">要入力</span>');
    });
    var rt = $("#recruit-table");
    if (rt) {
      rt.innerHTML = (D.recruitRows || []).map(function (r) {
        return '<tr><th scope="row">' + esc(r[0]) + "</th><td>" + r[1] + "</td></tr>";
      }).join("");
    }
    $all("[data-recruit-note]").forEach(function (el) { el.textContent = D.recruitNote || ""; });
    var p = $("[data-partners]");
    if (p) {
      if (D.partners && D.partners.length) {
        $("[data-partners-names]", p).textContent = D.partners.join("・");
      } else { p.hidden = true; }
    }
  }

  /* ---------- 平均寿命グラフ（SVG・数値はデータから描画） ---------- */
  function renderChart() {
    var box = $("#lifespan-chart");
    if (!box || !D.lifespan) return;
    var data = D.lifespan;
    var tip = document.createElement("div");
    tip.className = "chart-tip"; tip.hidden = true;

    function draw() {
      var W = Math.max(300, Math.round(box.clientWidth));
      var narrow = W < 560;
      var H = narrow ? 260 : 340;
      var m = { t: 34, r: narrow ? 44 : 56, b: 34, l: narrow ? 40 : 48 };
      var x0 = data[0][0], x1 = data[data.length - 1][0];
      var y0 = 14.0, y1 = 16.4;
      var iw = W - m.l - m.r, ih = H - m.t - m.b;
      function X(v) { return m.l + (v - x0) / (x1 - x0) * iw; }
      function Y(v) { return m.t + (1 - (v - y0) / (y1 - y0)) * ih; }
      var s = '<svg viewBox="0 0 ' + W + " " + H + '" width="' + W + '" height="' + H + '" role="img" aria-labelledby="chart-title chart-desc">' +
        '<title id="chart-title">ねこの平均寿命の推移（2010〜2025年）</title>' +
        '<desc id="chart-desc">2010年の14.36歳から2025年の16.00歳へ。縦軸は14歳から16.4歳の範囲で表示。</desc>';
      [14.0, 14.5, 15.0, 15.5, 16.0].forEach(function (v) {
        s += '<line class="grid" x1="' + m.l + '" x2="' + (W - m.r) + '" y1="' + Y(v) + '" y2="' + Y(v) + '"/>';
        s += '<text class="axis-text" x="' + (m.l - 8) + '" y="' + (Y(v) + 4) + '" text-anchor="end">' + v.toFixed(1) + "</text>";
      });
      s += '<text class="axis-text" x="' + (m.l - 8) + '" y="' + (m.t - 16) + '" text-anchor="end">（歳）</text>';
      var ticks = narrow ? [2010, 2015, 2020, 2025] : [2010, 2013, 2016, 2019, 2022, 2025];
      ticks.forEach(function (yr) {
        s += '<text class="axis-text" x="' + X(yr) + '" y="' + (H - m.b + 22) + '" text-anchor="middle">' + yr + "</text>";
      });
      var pts = data.map(function (d) { return X(d[0]).toFixed(1) + "," + Y(d[1]).toFixed(1); });
      s += '<path class="area" d="M' + X(x0) + "," + Y(y0) + " L" + pts.join(" L") + " L" + X(x1) + "," + Y(y0) + ' Z"/>';
      s += '<polyline class="line" points="' + pts.join(" ") + '"/>';
      data.forEach(function (d, i) {
        var last = i === 0 || i === data.length - 1;
        s += '<circle class="' + (last ? "dot-end" : "dot") + '" cx="' + X(d[0]) + '" cy="' + Y(d[1]) + '" r="' + (last ? 5.5 : 3.5) + '"/>';
      });
      var a = data[0], z = data[data.length - 1];
      s += '<text class="val" x="' + (X(a[0]) + 4) + '" y="' + (Y(a[1]) + 22) + '" text-anchor="start">' + a[1].toFixed(2) + "歳</text>";
      s += '<text class="val" x="' + X(z[0]) + '" y="' + (Y(z[1]) - 14) + '" text-anchor="end">' + z[1].toFixed(2) + "歳</text>";
      s += '<line class="cross" id="chart-cross" x1="0" x2="0" y1="' + m.t + '" y2="' + (H - m.b) + '" visibility="hidden"/>';
      s += '<rect id="chart-hit" x="' + m.l + '" y="' + m.t + '" width="' + iw + '" height="' + ih + '" fill="transparent"/>';
      s += "</svg>";
      box.innerHTML = s;
      box.appendChild(tip);

      var hit = $("#chart-hit", box), cross = $("#chart-cross", box), svg = $("svg", box);
      function show(clientX) {
        var r = svg.getBoundingClientRect();
        var px = (clientX - r.left) * (W / r.width);
        var yr = Math.round(x0 + (px - m.l) / iw * (x1 - x0));
        yr = Math.min(x1, Math.max(x0, yr));
        var d = data[yr - x0];
        cross.setAttribute("x1", X(yr)); cross.setAttribute("x2", X(yr)); cross.setAttribute("visibility", "visible");
        tip.hidden = false;
        tip.innerHTML = d[0] + "年　<b>" + d[1].toFixed(2) + "歳</b>";
        tip.style.left = (X(yr) * r.width / W) + "px";
        tip.style.top = (Y(d[1]) * r.height / H) + "px";
      }
      function hide() { tip.hidden = true; cross.setAttribute("visibility", "hidden"); }
      hit.addEventListener("pointermove", function (e) { show(e.clientX); });
      hit.addEventListener("pointerdown", function (e) { show(e.clientX); });
      hit.addEventListener("pointerleave", hide);
    }
    draw();
    var last = box.clientWidth, t;
    window.addEventListener("resize", function () {
      clearTimeout(t);
      t = setTimeout(function () { if (Math.abs(box.clientWidth - last) > 4) { last = box.clientWidth; draw(); } }, 120);
    });

    var tb = $("#lifespan-table");
    if (tb) {
      tb.innerHTML = "<table><caption class=\"visually-hidden\">ねこの平均寿命（年別）</caption><thead><tr><th scope=\"col\">調査年</th><th scope=\"col\">平均寿命</th></tr></thead><tbody>" +
        data.map(function (d) { return "<tr><td>" + d[0] + "年</td><td>" + d[1].toFixed(2) + "歳</td></tr>"; }).join("") + "</tbody></table>";
    }
  }

  /* ---------- 名鑑 ---------- */
  function displayName(r) {
    var p = r.publish || {};
    if (p.name === "full") return r.name;
    if (p.name === "initial") return r.initial + ".";
    return "名前は非公開";
  }
  function metaLine(r) {
    var p = r.publish || {}, a = [];
    if (p.age && r.age) a.push(r.age + "歳");
    if (p.pref && r.pref) a.push(r.pref);
    return a.join("・");
  }
  function photoBlock(r, label) {
    var p = r.publish || {};
    var badge = r.sample ? '<span class="sample-badge">掲載イメージ</span>' : "";
    if (p.photo && r.photo) {
      return '<div class="photo">' + badge + '<img src="' + esc(r.photo) + '" alt="ねこ研究員 ' + esc(displayName(r)) + 'の写真" loading="lazy"></div>';
    }
    if (p.photo) {
      return '<div class="photo" role="img" aria-label="写真の掲載枠">' + badge + '<span class="ph-label">' + esc(label || "ねこ研究員の写真") + "</span></div>";
    }
    var ch = p.name === "full" ? r.name.charAt(0) : (p.name === "initial" ? r.initial : "№");
    return '<div class="photo" role="img" aria-label="写真は非公開">' + badge + '<div class="no-photo"><b>' + esc(ch) + "</b>写真は非公開</div></div>";
  }
  function cardHTML(r, asLink) {
    var p = r.publish || {};
    var meta = metaLine(r);
    var inner = photoBlock(r) +
      '<div class="r-body"><span class="r-no">研究員番号 No.' + esc(r.id) + "</span>" +
      '<span class="r-name">' + esc(displayName(r)) + "</span>" +
      (meta ? '<span class="r-meta">' + esc(meta) + "</span>" : "") +
      (p.comment && r.comment ? '<p class="r-comment">' + esc(r.comment) + "</p>" : "") +
      "</div>";
    return asLink === false
      ? '<div class="r-card">' + inner + "</div>"
      : '<a class="r-card" href="/blogs/cat-researchers/' + esc(r.id) + '/" aria-label="' + esc(displayName(r)) + 'のプロフィールを見る">' + inner + "</a>";
  }
  /* 実データ＋掲載イメージ枠（wallPlaceholders の数だけ空き枠を足す） */
  function wallList() {
    var list = (D.researchers || []).slice();
    var n = D.wallPlaceholders || 0;
    var maxId = list.reduce(function (m, r) { return Math.max(m, parseInt(r.id, 10) || 0); }, 0);
    for (var i = 1; i <= n; i++) {
      list.push({ id: String(maxId + i).padStart(4, "0"), sample: true, placeholder: true, publish: { photo: true } });
    }
    return list;
  }
  function tileHTML(r, i) {
    var p = r.publish || {};
    if (r.placeholder) {
      return '<li class="tile tile--ph" style="--tone:' + (i % 5) + '"><div class="tile-face" aria-hidden="true"></div>' +
        '<span class="tile-name">ねこの名前</span><span class="tile-meta">No.' + esc(r.id) + "</span></li>";
    }
    var face;
    if (p.photo && r.photo) face = '<img src="' + esc(r.photo) + '" alt="ねこ研究員 ' + esc(displayName(r)) + 'の写真" loading="lazy">';
    else if (p.photo) face = '<span class="tile-ph">写真</span>';
    else face = '<span class="tile-mono">' + esc(p.name === "full" ? r.name.charAt(0) : (p.name === "initial" ? r.initial : "№")) + "</span>";
    var meta = (r.id === "0001" && p.age && r.age ? r.age + "歳" : "No." + r.id);
    return '<li class="tile"><a href="/blogs/cat-researchers/' + esc(r.id) + '/" aria-label="' + esc(displayName(r)) + 'のプロフィールを見る">' +
      '<div class="tile-face">' + face + "</div>" +
      '<span class="tile-name">' + esc(displayName(r)) + '</span><span class="tile-meta">' + esc(meta) + "</span></a></li>";
  }
  function renderWalls() {
    $all("[data-wall]").forEach(function (el) {
      var list = wallList();
      el.innerHTML = list.length ? list.map(tileHTML).join("") : '<li class="empty">ねこ研究員の紹介は、準備が整いしだい掲載します。</li>';
    });
    var real = (D.researchers || []).filter(function (r) { return !r.sample; }).length;
    $all("[data-wall-note]").forEach(function (el) {
      el.textContent = D.wallPlaceholders
        ? "※名前の入っていない枠は掲載イメージです。カイヌシさんの同意をいただいた研究員から、写真と名前を順に掲載します。"
        : "掲載中のねこ研究員：" + real + "匹（掲載に同意いただいたねこのみ）";
    });
  }
  function voiceHTML(r) {
    var p = r.publish || {};
    var face = p.photo && r.photo ? '<img src="' + esc(r.photo) + '" alt="' + esc(displayName(r)) + '">' : "";
    var who = displayName(r) + (p.age && r.age ? "（" + r.age + "歳）" : "") + "のカイヌシ" + (r.owner ? "・" + r.owner.replace(/^ユニアム代表・/, "ユニアム代表 ") : "さん");
    var title = r.id === "0001" ? "ユニアム代表・杉本" : r.voiceTitle || "カイヌシの声";
    var info = r.id === "0001" ? "小次郎 / 17歳 / 男の子" : r.voiceInfo || "";
    var types = r.researchTypes || (r.researchType ? [r.researchType] : []);
    var tag = types.map(function(type) {
      return type === "gut" ? '<span class="voice-research-tag voice-research-tag--gut">腸内研究</span>' : type === "oral" ? '<span class="voice-research-tag voice-research-tag--oral">口腔内研究</span>' : "";
    }).join("");
    if (tag) tag = '<div class="voice-research-tags">' + tag + '</div>';
    return '<figure class="voice"><div class="voice-header"><div class="voice-face">' + face + '</div><div class="voice-header-copy">' + tag +
      '<h3 class="voice-title">' + esc(title) + '</h3>' +
      (info ? '<p class="voice-cat-info">' + esc(info) + '</p>' : "") + '</div></div>' +
      '<blockquote><p>' + esc(r.comment) + '</p>' +
      (r.voiceNote ? '<p class="voice-study-note">' + esc(r.voiceNote) + '</p>' : "") + '</blockquote>' +
      (r.id === "0001" || r.voiceTitle ? "" : '<figcaption><a href="/blogs/cat-researchers/r' + esc(r.id) + '/">' + esc(who) + '</a></figcaption>') + '</figure>';
  }
  function renderVoices() {
    $all("[data-voices]").forEach(function (el) {
      var list = (D.researchers || []).filter(function (r) { return r.featured && r.comment && (r.publish || {}).comment; }).slice(0, 3);
      var n = Math.min(D.voicePlaceholders || 0, 3 - list.length);
      for (var i = 0; i < n; i++) list.push({ placeholder: true });
      el.innerHTML = list.map(voiceHTML).join("");
      el.hidden = !list.length;
    });
  }

  /* 掲載範囲のプレビュー */
  function renderConsentDemo() {
    var form = $("#consent-demo");
    if (!form) return;
    var base = { id: "0000", sample: true, name: "そら", initial: "S", age: 18, pref: "宮城県", photo: null,
      comment: "朝はいちばんに起こしにきます。これからも一緒に、ゆっくり年を重ねたいです。" };
    function update() {
      var fd = new FormData(form);
      base.publish = {
        photo: fd.get("cd-photo") === "on", name: fd.get("cd-name"),
        age: fd.get("cd-age") === "on", pref: fd.get("cd-pref") === "on", comment: fd.get("cd-comment") === "on"
      };
      $("#consent-preview").innerHTML = cardHTML(base, false);
    }
    form.addEventListener("change", update);
    update();
  }

  /* 研究員プロフィール詳細 */
  function renderProfile() {
    var el = $("#profile");
    if (!el) return;
    var pathId = location.pathname.match(/\/longevitylab\/researchers\/r([^/]+)\/?$/);
    var id = pathId ? decodeURIComponent(pathId[1]) : (location.hash || "").replace(/^#r/, "");
    var list = D.researchers || [];
    var r = list.filter(function (x) { return x.id === id; })[0] || list[0];
    if (!r) { el.innerHTML = '<p class="empty">研究員が見つかりませんでした。<a href="/blogs/cat-researchers/">名鑑に戻る</a></p>'; return; }
    var p = r.publish || {};
    var rows = [["研究員番号", "No." + r.id]];
    if (p.research && r.profileConsent && r.researchParticipation) rows.push(["参加している研究", r.researchParticipation.join("・")]);
    if (p.age && r.age) rows.push(["年齢", r.age + "歳" + (r.ageAsOf ? "（" + r.ageAsOf + "時点）" : "")]);
    if (p.sex && r.profileConsent && r.sex) rows.push(["性別", r.sex]);
    if (p.breed && r.profileConsent && r.breed) rows.push(["品種", r.breed]);
    if (p.pref && r.pref) rows.push(["都道府県", r.pref]);
    if (p.reason && r.reason) rows.push(["参加した理由", r.reason]);
    document.title = displayName(r) + "｜ねこ研究員名鑑｜ユニアム";
    el.innerHTML =
      "<div>" + photoBlock(r, "ねこ研究員の写真") + "</div>" +
      "<div>" + (r.sample ? '<span class="chip">掲載イメージ</span>' : "") +
      '<h1 style="font-size:var(--s-xl);margin-top:12px">' + esc(displayName(r)) + "</h1>" +
      "<dl>" + rows.map(function (x) { return "<dt>" + x[0] + "</dt><dd>" + esc(x[1]) + "</dd>"; }).join("") + "</dl>" +
      (p.comment && r.comment ? "<blockquote>" + esc(r.comment) + "<cite>カイヌシさんからの一言</cite></blockquote>" : "") +
      '<p class="small muted" style="margin-top:24px">掲載内容は、カイヌシさんの同意をいただいた範囲のみを表示しています。</p>' +
      '<div class="btn-row" style="margin-top:28px"><a class="btn btn--ghost" href="/blogs/cat-researchers/">名鑑に戻る</a></div></div>';
    window.addEventListener("hashchange", function () { renderProfile(); window.scrollTo(0, 0); }, { once: true });
  }

  /* 研究だより */
  function renderPosts() {
    var el = $("#posts");
    if (!el) return;
    var list = (D.posts || []).slice().sort(function (a, b) { return (b.date || "").localeCompare(a.date || ""); });
    el.innerHTML = list.length ? list.map(function (p) {
      var ext = /^https?:/.test(p.url);
      return '<a class="post" href="' + esc(p.url) + '"' + (ext ? ' target="_blank" rel="noopener"' : "") + ">" +
        '<span><time datetime="' + esc(p.date) + '">' + esc((p.date || "").replace(/-/g, ".")) + '</time>　<span class="chip">' + esc(p.category) + "</span></span>" +
        "<h3>" + esc(p.title) + "</h3>" + (p.excerpt ? '<p class="small muted">' + esc(p.excerpt) + "</p>" : "") + "</a>";
    }).join("") : '<p class="empty">お知らせは準備中です。</p>';
  }

  renderChrome();
  bindData();
  renderChart();
  renderWalls();
  renderVoices();
  renderConsentDemo();
  renderProfile();
  renderPosts();
})();
